import { render } from "./EmailControl.vue?vue&type=template&id=7cef271f&scoped=true"
import script from "./EmailControl.vue?vue&type=script&lang=js"
export * from "./EmailControl.vue?vue&type=script&lang=js"

import "./EmailControl.vue?vue&type=style&index=0&id=7cef271f&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cef271f"]])

export default __exports__